<template>
	<div>
		<el-row>
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
				<div class="nav-btn">
					<router-link to="/rules" :class="current=='Rules' ? 'nav-btn-active' : ''">规则</router-link>
					<router-link to="/news" :class="current=='News' ? 'nav-btn-active' : ''">通知</router-link>
					<router-link to="/help" :class="current=='Help' ? 'nav-btn-active' : ''">帮助</router-link>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
				<div class="content_main clearfix">
					<div class="newslist right-main">
						<ul class="jjbq-box newslist3">

							<li class="clearfix">
								<div class="news-box clearfix">
									<div class="news_pic"></div>
									<div class="news_font">
										<div class="news-dbo">
											<h2><a href="/?news_1/33.html">陪聊必看规则</a></h2>
											<p>仅推广有社交需求的用户，如果出现以下情况，将封号处理一、色情/涉黄违规类&nbsp;禁止涉黄、卖淫嫖娼：主动...</p>
										</div>
										<div class="news_ly">
											<span>时间：2023-10-09　</span>
											<span>浏览量：645</span>
										</div>
									</div>
								</div>
							</li>
							<li class="clearfix">
								<div class="news-box clearfix">
									<div class="news_pic"></div>
									<div class="news_font">
										<div class="news-dbo">
											<h2><a href="/?news_1/33.html">陪聊必看规则</a></h2>
											<p>仅推广有社交需求的用户，如果出现以下情况，将封号处理一、色情/涉黄违规类&nbsp;禁止涉黄、卖淫嫖娼：主动...</p>
										</div>
										<div class="news_ly">
											<span>时间：2023-10-09　</span>
											<span>浏览量：645</span>
										</div>
									</div>
								</div>
							</li>
							<li class="clearfix">
								<div class="news-box clearfix">
									<div class="news_pic"></div>
									<div class="news_font">
										<div class="news-dbo">
											<h2><a href="/?news_1/33.html">陪聊必看规则</a></h2>
											<p>仅推广有社交需求的用户，如果出现以下情况，将封号处理一、色情/涉黄违规类&nbsp;禁止涉黄、卖淫嫖娼：主动...</p>
										</div>
										<div class="news_ly">
											<span>时间：2023-10-09　</span>
											<span>浏览量：645</span>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" >
				<el-pagination
				  background
				  layout="prev, pager, next"
				  :total="100">
				</el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import moment from '@/utils/moment'
	export default{
		data(){
			return{
				current:'Help'
			}
		},
		created() {
			this.current=this.$route.name;
		},
		filters: {
			// 时间格式化
			time(val) {
				return moment(val * 1000).format('YYYY-MM-DD HH:mm');
			},
		}
	}
</script>

<style>
	.content_main {
		width: 100%;
		padding-top: 10px;
	}

	.newslist3 {
		margin-bottom: 20px;
	}

	.jjbq-box {
		position: relative;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
	}

	ul,
	ol {
		padding-left: 0;
		margin: 0;
	}

	.newslist li {
		width: 100%;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
		padding-bottom: 20px;
		margin-bottom: 20px;
		border-bottom: 1px dashed #d0d4d1;
	}

	.jjbq-box li {
		-webkit-box-flex: 0;
	}

	.news-box {
		width: 100%;
	}

	.news_pic {
		width: 100%;
		margin-bottom: 15px;
	}

	.news-box h2 {
		line-height: 30px;
		font-size: 15px;
		margin-bottom: 5px;
	}

	.news-box p {
		color: #7b7b7b;
		font-size: 14px;
		line-height: 24px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		word-break: break-all;
	}

	.news-box .news_ly {
		margin-top: 15px;
	}

	.news-box .news_ly span {
		color: #777;
		font-size: 14px;
		line-height: 20px;
		padding-right: 20px;
	}
	.nav-btn{
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 20px;
	}
	.nav-btn a{
		color: #2c3096;
		font-size: 14px;
		line-height: 35px;
		padding: 0 12px;
		display: block;
		border: 1px solid #2c3096;
		border-radius: 5px;
		margin: 0 4px 8px;
		cursor: pointer;
	}
</style>